import type { ListQuery } from './query'
import type { ListSchema } from './schema'

export interface ListViewState {
  readonly filters: Array<{ readonly type: string; readonly values: string[] }>
  readonly groupBy: string | null
}

export function serializeQuery(query: ListQuery): ListViewState {
  return {
    filters: Object.entries(query.appliedFacets).map(([type, values]) => ({
      type,
      values: [...values],
    })),
    groupBy: query.groupBy[0] ?? null,
  }
}

export function applySavedView<T>(
  dto: ListViewState,
  schema: ListSchema<T>,
  aliases: Readonly<Record<string, string>> = {},
): Partial<ListQuery> {
  const facetableKeys = new Set(
    schema.fields.filter(field => field.facetable).map(field => field.key),
  )
  const groupableKeys = new Set(
    schema.fields.filter(field => field.groupable).map(field => field.key),
  )
  const appliedFacets: Record<string, readonly string[]> = Object.create(null)

  for (const filter of dto.filters) {
    const key = aliases[filter.type] ?? filter.type
    if (!facetableKeys.has(key)) continue
    appliedFacets[key] = filter.values.map(value => String(value))
  }

  const aliasedGroupBy =
    dto.groupBy === null ? null : (aliases[dto.groupBy] ?? dto.groupBy)
  const groupBy =
    aliasedGroupBy !== null && groupableKeys.has(aliasedGroupBy)
      ? [aliasedGroupBy]
      : []

  return { appliedFacets, groupBy }
}
